import { useResidentContext } from "app/features/residents/provider/ResidentProvider";
import { View } from "react-native";
import { CalendarViewTemplate } from "app/features/calendar/templates/CalendarViewTemplate";
import LoadingSpinner from "ui/atoms/spinner/LoadingSpinner";

export function ResidentCalendarScreen() {
  const { resident } = useResidentContext();

  return (
    <View className="flex-1">
      {resident?.id ? (
        <CalendarViewTemplate
          residentId={resident.id}
          locationId={resident.location?.id}
        />
      ) : (
        <LoadingSpinner />
      )}
    </View>
  );
}
